import { env } from './env';
import { nativeRuntime } from '@/shared/lib/nativePlatform';

/**
 * L'INDIRIZZO DEL FRONT-END DA DICHIARARE AL SERVER.
 *
 * Il BE compone i collegamenti assoluti delle email transazionali — benvenuto, invito, reimposta
 * password, OTP — a partire dall'header `baseEndpoint` che gli manda il client.
 *
 * ⚠️ Qui c'era `window.location.origin`, scritto in nove punti. Su web e' la cosa giusta:
 * `window.location` e' l'indirizzo vero per definizione, domini personalizzati compresi. **Dentro
 * l'app no**: nell'APK la WebView carica la pagina da un'origine locale — la dichiarano le
 * preferenze `scheme` e `hostname` in `cordova/config.xml` — che non e' un indirizzo web.
 *
 * ⚠️ La nota qui sotto diceva «il recupero password parte dall'app, quindi il risultato era
 * un'email con un collegamento a `https://localhost/...`». **Provato sul telefono il
 * 09-09-2026: quel flusso manda un codice, non un link** — quindi il recupero password non era
 * fra i casi rotti, e questo commento lo dava per tale.
 *
 * L'header serve comunque, e per le email che i collegamenti **li contengono**: benvenuto,
 * invito, e ogni futura comunicazione con un «apri qui». Il difetto e' vero, il suo esempio
 * era sbagliato — e un esempio sbagliato in un commento e' peggio di nessun esempio, perche'
 * chi legge lo prende come la prova. Peggio ancora, siccome l'header **c'era
 * ed era valorizzato**, il ripiego del BE (`FrontendBaseUrl`) non scattava — un header assente
 * avrebbe funzionato meglio di uno sbagliato.
 */
export function baseEndpoint(): string {
  /*
   * ⚠️ `runtimeNativo()`, e non la domanda «siamo nativi?» posta al guscio.
   *
   * Il difetto descritto qui sopra era stato chiuso **per il guscio precedente** e restava aperto
   * per quello che si spedisce: quella domanda, posta all'altro, risponde `false` in un APK
   * Cordova — quindi si tornava `window.location.origin`, che li' e' un'origine locale della
   * WebView. Un'email con un collegamento partiva di nuovo verso un indirizzo che esiste solo
   * dentro il telefono: lo stesso guasto, con un altro guscio sotto.
   *
   * ⚠️ Ed e' peggio di un header mancante, per la ragione scritta sopra: l'header **c'era ed
   * era valorizzato**, quindi il ripiego del BE (`FrontendBaseUrl`) non scattava. Un difetto
   * che disattiva la propria rete di sicurezza.
   *
   * ⚠️ Questo era anche **l'unico import statico** di un pacchetto di quel guscio in tutto il
   * codice — tutti gli altri erano `await import(...)` dentro un ramo. Toglierlo e' il pezzo che
   * ha reso possibile disinstallarlo senza rompere la compilazione: gli import dinamici si
   * possono lasciare in un ramo che non viene percorso, uno statico no. Il 09-09-2026 quel
   * guscio e' stato rimosso, e questa riga e' la ragione per cui la rimozione e' stata una
   * cancellazione e non un cantiere.
   */
  return nativeRuntime() !== 'web' ? env.VITE_FE_BASE_URL : window.location.origin;
}
